import { noop } from 'lodash-es';
import { useEffect, useState } from 'react';
import { EventEntitySearchBox } from 'src/components/Accordions/EventEntitySearchBox';
import { useFilterQueryContext } from 'src/contexts/FilterQueryContext';
import { ContentId } from 'src/utils/constants/contentId';
import { OnSaleEventQuery } from 'src/WebApiController';

export function OnSaleEventSearchBox() {
  const [searchText, setSearchText] = useState('');

  const { filterQuery: onSaleEventQuery } =
    useFilterQueryContext<OnSaleEventQuery>();

  useEffect(() => {
    setSearchText(onSaleEventQuery.searchText ?? '');
  }, [onSaleEventQuery.searchText]);

  return (
    <EventEntitySearchBox
      minWidth={350}
      placeholderContentId={ContentId.SearchEventPlaceholderText}
      onIdLookup={noop}
      searchText={searchText}
      setSearchText={setSearchText}
    />
  );
}
